module.exports = __webpack_public_path__ + "8248edd93f6a6577a378ad7adb81f92b.png";